































































































































































































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import Message from '../../../api/v2/models/message'
import api from '../../../api/v2/api'
import {makeChannel} from '../../../../action_cable/cable'
import MessageForm from '../../../api/v2/forms/message'
import ThreadForm from '../../../api/v2/forms/thread'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import AttachmentForm from "../../../api/v2/forms/attachment";
import Axios from "axios";
import AiChatQuestion from "../../../api/v2/models/ai_chat_question";
import url_path from "../../../../helpers/url_helper";

const logo = require("../../../../images/edbase_logo.gif").default;

@Component({
  methods: {url_path},
  components: {
    FileIcon
  }
})
export default class MesageContainer extends Vue {
  @Prop({default: 'Lesson'}) targetableType: 'Lesson' | 'UserGoal' | 'Exam' | 'Question'
  @Prop({required: true}) targetableId: string
  @Prop({required: false}) toggleCreateThreadBtn: (value: boolean) => undefined
  @Prop({default: false}) usingDeepseek: boolean

  messages: Message[] = []
  chatContent: string = ''
  threadId: string = ''
  limitMessage: number = 100
  messageCount: number = 0
  showComponent: boolean = true
  chanel: any = null
  attachments = []
  isDragging = false
  codeDialog = false
  dialogHTML = ""
  inProgress = false
  aiChatQuestions: AiChatQuestion[] = []

  logo = logo

  get nextDayFormatted(): string {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    return `${tomorrow.getMonth() + 1}月${tomorrow.getDate()}日`;
  }

  createChannel() {
    this.chanel = makeChannel(
      'ChatLessonChannel',
      async (e) => {
        if (e.content == 'Finished') {
          this.inProgress = false
          setTimeout(() => document.getElementById('chat-input').focus(), 400)
          const message = await api.message.show(e.message_id)
          const messageIndex = this.messages.findIndex(m => m.id === e.message_id)
          if (messageIndex > -1) {
            this.messages.splice(messageIndex, 1, message)
          }
          this.scrollToLast()
        } else if (e.content == 'Stop finished') {
          this.inProgress = false
          setTimeout(() => document.getElementById('chat-input').focus(), 400)
        } else {
          ;(document.getElementById('chat-input') as HTMLInputElement).value = ''
          if (document.getElementsByClassName('typing-animation').length > 0) {
            document.getElementsByClassName('typing-animation')[0].remove()
          }

          if (e.content) {
            const messageEl = document.getElementById(`message-content-${e.message_id}`)
            if (messageEl) {
              messageEl.innerHTML = e.content
            }
          }

          if (e.reasoning_content) {
            const messageReasoningContainer = document.getElementById(`message-reasoning-container-${e.message_id}`)
            if (messageReasoningContainer)
              messageReasoningContainer.style.display = 'flex'

            const indicatorDot =  <HTMLElement> messageReasoningContainer.querySelector(".streaming-indicator")
            indicatorDot.style.display = e.content ? 'none' :'block'

            const messageReasoningEl = document.getElementById(`message-reasoning-content-${e.message_id}`)
            if (messageReasoningEl) {
              messageReasoningEl.innerText = e.reasoning_content
            }
          }

          this.scrollToLast()
        }
      },
      () => {
        this.chanel.send({
          action: 'follow',
          data: {
            targetable_id: this.targetableId,
            targetable_type: this.targetableType
          }
        })
      },
    )
  }

  reconnectChannel() {
    if (this.chanel) {
      this.chanel.unsubscribe()
      this.chanel = null
    }
    this.createChannel()
  }

  async createMessage(options = {
    aiChatQuestionId: undefined
  }) {
    this.stopStream()
    try {
      this.inProgress = true
      let input = (document.getElementById('chat-input') as HTMLInputElement)
      let content = input.value
      const messageForm = new MessageForm()
      messageForm.content = content.trim()
      messageForm.targetableId = parseInt(this.targetableId)
      messageForm.targetableType = this.targetableType
      messageForm.attachmentIds = this.attachments.filter((attachment) =>
        !attachment.isDeleted && attachment.serverId
      ).map((attachment) => attachment.serverId)
      messageForm.aiChatQuestionId = options.aiChatQuestionId
      if (document.querySelector(".type-question") !== null) {
        let question_data: any = {}
        question_data.data = {}
        document.querySelectorAll(".question-container").forEach((element, index) => {
          if (element.querySelector(".type-question").textContent === "radio") {
            question_data.data[index] = {}
            question_data.data[index].fieldType = "radio"
            if (element.querySelector(".title") !== null) {
              question_data.data[index].order = element.querySelector(".title").textContent.trim()
            } else {
              question_data.data[index].order = "Only 1 question"
            }
            question_data.data[index].question = element.querySelector(".question-body-preview-client").textContent.trim()

            question_data.data[index].allAnswers = [];
            element.querySelectorAll('input[type="radio"]').forEach((radio: any) => {
              let label = radio.closest(".v-radio").querySelector("label").textContent.trim()

              question_data.data[index].allAnswers.push(label);

              if (radio.checked) {
                question_data.data[index].userAnswer = label;
              }
              let parentDiv = radio.closest('.flex');
              let backgroundColor = window.getComputedStyle(parentDiv).backgroundColor;
              if (backgroundColor === 'rgb(188, 224, 253)') {
                question_data.data[index].correctAnswer = label;
              }
            })
            question_data.data[index].skills = element.querySelector(".skill-text").textContent.trim()
            question_data.data[index].examExplain = element.querySelector(".exam-explain").textContent.trim()
            messageForm.metadata = question_data
          } else if (element.querySelector(".type-question").textContent === "textarea") {
            question_data.data[index] = {}
            question_data.data[index].fieldType = "textarea"
            if (element.querySelector(".title") !== null) {
              question_data.data[index].order = element.querySelector(".title").textContent.trim()
            } else {
              question_data.data[index].order = "Only 1 question"
            }
            question_data.data[index].question = element.querySelector(".question-body-preview-client").textContent.trim()
            question_data.data[index].total_point = element.querySelector(".summary-sore").children[2].textContent.trim()
            let list_skills = Array.from(element.querySelector(".summary-sore").nextElementSibling.children)
                .filter(el => el.querySelector(".skill-text"))
            question_data.data[index].skills = []
            for (let i = 0; i < list_skills.length; i++) {
              if (list_skills[i].classList.contains("flex")) {
                let skill_items: any = {}
                skill_items.title = list_skills[i].querySelector(".skill-text").textContent.trim()
                skill_items.skill_item = []
                list_skills[i].querySelectorAll(".skill-table tbody tr").forEach((item) => {
                  let skill_item: any = {}
                  if (item.classList.contains("font-weight-bold")) {
                    skill_item.total_point = item.children[1].textContent.trim()
                  } else {
                    skill_item.criteria = item.children[0].textContent.trim()
                     skill_item.score = item.children[1].textContent.trim()
                    skill_item.explanation = item.children[2].textContent.trim()
                  }
                  skill_items.skill_item.push(skill_item)
                })
                question_data.data[index].skills.push(skill_items)
              }
            }
            messageForm.metadata = question_data
          } else if (element.querySelector(".type-question").textContent === "textfield") {
            // question_data.data[index] = {}
            // question_data.data[index].fieldType = "textfield"
            // if (element.querySelector(".title") !== null) {
            //   question_data.data[index].order = element.querySelector(".title").textContent.trim()
            // } else {
            //   question_data.data[index].order = "Only 1 question"
            // }
            // const pElement = element.querySelector('p');
            // const tempDiv = document.createElement('div');
            // tempDiv.innerHTML = pElement.innerHTML;
            // debugger
            // const spans = tempDiv.querySelectorAll('span');
            // spans.forEach(span => span.remove());
            // const textOnly = tempDiv.textContent || tempDiv.innerText || '';
            // question_data.data[index].question = textOnly.trim()
            // const inputUserAnswers: any = element.querySelectorAll(".question-body-preview-client")
            // let dataInputAnswer = {}
            // for (let i = 0; i < inputUserAnswers.length; i++) {
            //   dataInputAnswer[i+1].userAnswer = inputUserAnswers[i].querySelector("input").value
            //   dataInputAnswer[i+1].answerCorrect = inputUserAnswers[i].querySelector(".textfield-question-answer").textContent.trim()
            // }
            // question_data.data[index].dataInputAnswer = dataInputAnswer
            // question_data.data[index].skills = element.querySelector(".skill-text").textContent.trim()
            // question_data.data[index].examExplain = element.querySelector(".exam-explain").textContent.trim()
          }
        })
      }

      this.threadId = this.$route.query['thread_id'] ? String(this.$route.query['thread_id']) : this.threadId
      messageForm.threadId = this.threadId

      let message = await api.message.create(messageForm)
      if (this.threadId == '') {
        this.threadId = message.threadId
      }
      const result = await api.message.index({
        targetableId: this.targetableId,
        targetableType: this.targetableType,
        threadId: this.threadId
      })
      this.messages = result[1]
      this.toggleCreateThreadBtn(!!this.messages.length)
      this.messageCount = result[0].totalMessage
      this.limitMessage = result[0].limitMessage
      this.chatContent = ''
      this.attachments = []
      setTimeout(() => input.focus(), 200)
      input.style.setProperty("height", "unset")
      this.scrollToLast()
    } catch (e) {
      console.error(e)
    } finally {
    }
  }

  @Watch('$route')
  async changeRoute() {
    this.stopStream()
    const threadId = this.$route.query['thread_id'] || ''
    this.threadId = threadId.toString()
    const result = await api.message.index({
      targetableId: this.targetableId,
      targetableType: this.targetableType,
      threadId: threadId.toString()
    })
    this.messages = result[1]
    this.toggleCreateThreadBtn(!!this.messages.length)
    this.messageCount = result[0].totalMessage
    this.limitMessage = result[0].limitMessage
    this.chatContent = ''
    this.attachments = []
    this.scrollToLast()
  }

  scrollToLast() {
    setTimeout(() => {
      let lastMessage = document.querySelector("#last-message") as HTMLElement
      if (lastMessage) {
        lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }
    }, 100)
  }

  async clearMessage() {
    try {
      ;[this.messages] = await Promise.all([
        api.message.clear({
          targetableId: this.targetableId,
          targetableType: this.targetableType
        })
      ])
    } catch (e) {}
  }

  async stopGenerate() {
    try {
      ;[this.messages] = await Promise.all([
        api.message.stopGenerate({
          targetableId: this.targetableId,
          targetableType: this.targetableType
        })
      ])
    } catch (e) {}
  }

  async created() {
    try {
      const threadId = this.$route.query['thread_id'] || ''
      let result = await api.message.index({
        targetableId: this.targetableId,
        targetableType: this.targetableType,
        threadId: threadId.toString()
      })
      this.messages = result[1]
      this.toggleCreateThreadBtn(!!this.messages.length)
      this.messageCount = result[0].totalMessage
      this.limitMessage = result[0].limitMessage
      this.createChannel()
      // TODO: Channel send double time
      this.chanel.send({
        action: 'follow',
        data: {
          targetable_id: this.targetableId,
          targetable_type: this.targetableType
        }
      })
    } catch (e) {}
  }

  async createThread() {
    try {
      const threadForm = new ThreadForm()
      threadForm.targetableId = parseInt(this.targetableId)
      threadForm.targetableType = this.targetableType

      let thread = await api.thread.create(threadForm)

      this.$router
          .push({
            query: { ...this.$route.query, thread_id: thread.id.toString() }
          })
          .catch((error) => {
            if (error.name != 'NavigationDuplicated') {
              throw error
            }
          })
    } catch (e) {}
  }

  async mounted() {
    document.getElementById('chat-input').addEventListener('input', this.autoExpandTextarea);

    (this.$refs.chatInput as HTMLTextAreaElement).addEventListener('paste', e => {
      e.preventDefault()
      if (e.clipboardData.files.length) {
        (this.$refs.file as HTMLInputElement).files = e.clipboardData.files
        this.handleFileChange()
      } else {
        navigator.clipboard
            .readText()
            .then(cliptext => this.chatContent += cliptext);
      }
    });

    document.addEventListener("click", this.handleCopy)
    document.addEventListener("click", this.handleZoomHighlight)
    document.addEventListener("click", this.handleZoomImage)

    this.$nextTick(function () {
      setTimeout(() => { this.scrollToLast() }, 250)
    })

    this.aiChatQuestions = await api.aiChatQuestionApi.index({context: this.chatQuestionContext(), targetableId: this.targetableId, targetableType: this.targetableType})
  }

  updated() {
    document.getElementById('chat-input').dispatchEvent(new Event("input"))
  }

  beforeDestroy() {
    document.removeEventListener("click", this.handleCopy)
    document.removeEventListener("click", this.handleZoomHighlight)
  }

  async refresh() {
    this.reconnectChannel()
    const threadId = this.$route.query['thread_id'] || ''
    let result = await api.message.index({
      targetableId: this.targetableId,
      targetableType: this.targetableType,
      threadId: threadId.toString()
    })
    this.messages = result[1]
    this.toggleCreateThreadBtn(!!this.messages.length)
    this.messageCount = result[0].totalMessage
    this.limitMessage = result[0].limitMessage
    console.log('Component reloaded')
  }

  autoExpandTextarea() {
    const textarea = document.getElementById('chat-input') as HTMLTextAreaElement;
    if (textarea) {
      textarea.setAttribute('style', 'height: auto !important');

      const newHeight = textarea.scrollHeight + 2;

      const maxHeight = 200;

      // Apply the height with !important
      textarea.setAttribute('style', `height: ${Math.min(newHeight, maxHeight)}px !important; overflow-y: ${newHeight > maxHeight ? 'auto' : 'hidden'} !important;`);
    }
  }

  handleFileChange() {
    Array.from((this.$refs.file as HTMLInputElement).files).forEach((file) => {
      if (this.attachments.find((attachment) => attachment.file.name === file.name && attachment.file.size === file.size)) {
        return
      }

      const attachment = {
        isDeleted: false,
        isUploadCompleted: false,
        serverId: null,
        progressPercentage: 5,
        file: file as File
      }

      if (/png|jpeg|jpg/.test(attachment.file.type) && (10 * 1024 * 1024 < attachment.file.size)) {
        alert("Limit 10 MB per image.")
        return
      }
      // } else if (20 * 1024 * 1024 < attachment.file.size) {
      //   alert("Limit 20 MB per file.")
      //   return
      // }

      if (/png|jpeg|jpg/.test(attachment.file.type)) {
        this.attachments.push(attachment)
        this.handleUpload(attachment)
      }
    })
  }

  dragover(e) {
    if (this.usingDeepseek) return
    e.preventDefault()
    this.isDragging = true
  }

  dragleave() {
    if (this.usingDeepseek) return
    this.isDragging = false
  }

  drop(e) {
    if (this.usingDeepseek) return
    (this.$refs.file as HTMLInputElement)
        .files = e.dataTransfer.files
    this.handleFileChange()
    this.isDragging = false
    e.preventDefault()
  }

  getFileName(attachment) {
    return this.getFileNameFromString(attachment.file.name)
  }

  getFileNameFromString(string) {
    return string.replace(/\.[^/.]+$/, "")
  }

  getFileExt(attachment) {
    return this.getFileExtFromString(attachment.file.name)
  }

  getFileExtFromString(string) {
    return string.split('.').pop().toUpperCase()
  }

  addAttachment() {
    (this.$refs.file as HTMLInputElement).click()
  }

  async handleUpload(attachment) {
    const attachmentForm = new AttachmentForm()
    attachmentForm.filename = attachment.file.name

    const attachmentRes = await api.attachment.create(attachmentForm)

    const parseProgress = (progressEvent) => {
      const progressPercentage =
          (progressEvent.loaded / progressEvent.total) * 100;
      if (progressPercentage > 98) {
        attachment.progressPercentage = 98
      } else if (progressPercentage > 5) {
        attachment.progressPercentage = progressPercentage
      }
    }

    const res = await Axios.put(attachmentRes.uploadUrl, attachment.file, {
      headers: {
        'Content-Type': attachment.file.type,
        'Content-Disposition': `attachment; filename=${attachment.file.name}`
      },
      onUploadProgress: parseProgress
    })

    if (res.status === 200) {
      attachment.isUploadCompleted = true
      attachment.serverId = attachmentRes.id
    } else {
      return alert("Error: Upload failed!")
    }


  }

  deleteAttachment(index) {
    this.attachments[index].isDeleted = true
  }

  openUrl(url) {
    window.open(url, "_blank")
  }

  canSubmit() {
    return (this.chatContent.trim() != "" || this.attachments.filter(attachment => !attachment.isDeleted && attachment.isUploadCompleted).length) 
           && this.messageCount < this.limitMessage;
  }

  handleCopy(e) {
    if (e.target.classList.contains("highlight-copy-btn")) {
      navigator.clipboard.writeText(e.target.closest(".highlight-container").querySelector("code").innerText)
      e.target.querySelector(".action-name").innerText = "コピーしました！"

      setTimeout(() => {
        e.target.querySelector(".action-name").innerText = "コードをコピーする"
      }, 1000)
    }
  }

  handleZoomHighlight(e) {
    if (e.target.classList.contains("highlight-zoom-btn")) {
      this.dialogHTML = e.target.closest(".highlight-container").outerHTML
      this.codeDialog = true
    }
  }

  handleZoomImage(e) {
    if (e.target.classList.contains("message-attachment-image")) {
      this.dialogHTML = e.target.outerHTML
      this.codeDialog = true
    }
  }

  handleEnterChatForm(e) {
    if (e.keyCode == 13 && !e.shiftKey) {
      e.preventDefault()
      if (this.canSubmit()) this.createMessage()
      return false
    }
  }

  copyMessage(index: number) {
    navigator.clipboard.writeText(this.messages[index].contentRaw)
  }

  async regenerate(index: number) {
    this.stopStream()
    await api.message.regenerate(this.messages[index].id)
    this.threadId = this.$route.query['thread_id'] ? String(this.$route.query['thread_id']) : this.threadId
    const result = await api.message.index({
      targetableId: this.targetableId,
      targetableType: this.targetableType,
      threadId: this.threadId
    })
    this.messages = result[1]
    this.toggleCreateThreadBtn(!!this.messages.length)
    this.messageCount = result[0].totalMessage
    this.limitMessage = result[0].limitMessage
  }

  speechMedia: HTMLAudioElement = null

  async speech(index: number,) {
    this.stopStream()
    const message = this.messages[index]
    message.speechPlaying = true

    try {
      if (!message.cachedSpeechUrl) {
        const speechData = await api.message.speech(message.id)
        message.cachedSpeechUrl = speechData.data.url
      }

      this.speechMedia = this.$refs.speechMedia as HTMLAudioElement
      this.speechMedia.setAttribute("src", message.cachedSpeechUrl)
      this.speechMedia.addEventListener("ended", () => {
        message.speechPlaying = false
      })

      await this.speechMedia.play()
    } catch (error) {
      this.speechMedia = null
      message.speechPlaying = false
      console.error('Error streaming audio:', error)
    }
  }

  stopStream() {
    if (this.speechMedia) {
      try {
        this.speechMedia.pause()
      } catch (error) {}

      this.messages.forEach((message) => { message.speechPlaying = false })
    }

    this.speechMedia = null
  }

  chatQuestionContext() {
    switch (this.targetableType) {
      case "Lesson":
        return ["lesson"]
      case "Exam":
        return ["question"]
      case "Question":
        return ["question"]
      case "UserGoal":
        return ["goal"]
      default:
        return []
    }
  }

  sendSuggestQuestion(aiChatQuestion: AiChatQuestion) {
    if (this.inProgress) return

    this.createMessage({aiChatQuestionId: aiChatQuestion.id})
  }
}

